import { Tenancy_Rich_Asset_Type_Enum_Ps_Enum } from '@pypestream/api-services';
import { JSONSchema7 } from 'json-schema';

// Filter out undefined values and convert to string array
const richAssetTypeEnum = Object.values(Tenancy_Rich_Asset_Type_Enum_Ps_Enum)
  .filter(
    (value): value is Tenancy_Rich_Asset_Type_Enum_Ps_Enum =>
      value !== undefined
  )
  .map((value) => value.toString());

export const tableRowSchema: JSONSchema7 = {
  $schema: 'http://json-schema.org/draft-07/schema#',
  title: 'TableRow',
  type: 'object',
  properties: {
    richAssetType: {
      type: 'string',
      enum: richAssetTypeEnum,
      description: 'Type of rich asset if any',
    },
    answerRequired: {
      type: 'boolean',
      description: 'Whether an answer is required for this node',
    },
    variables: {
      type: 'array',
      items: {
        type: 'string',
      },
      description: 'List of variables associated with this node',
    },
  },
  dependencies: {
    richAssetType: {
      oneOf: [
        {
          properties: {
            richAssetType: {
              not: {
                enum: [
                  Tenancy_Rich_Asset_Type_Enum_Ps_Enum.None.toString(),
                  'none',
                  'None',
                ],
              },
            },
            answerRequired: {
              const: true,
            },
          },
        },
      ],
    },
    variables: {
      oneOf: [
        {
          properties: {
            variables: {
              type: 'array',
              minItems: 1,
              items: {
                type: 'string',
                minLength: 1,
              },
            },
            answerRequired: {
              const: true,
            },
          },
        },
      ],
    },
  },
} as const;

export const tableSchema: JSONSchema7 = {
  $schema: 'http://json-schema.org/draft-07/schema#',
  title: 'Table',
  type: 'array',
  items: tableRowSchema,
} as const;
